<div class="flex flex-col w-96 gap-5">
	<div class="flex flex-col rounded bg-grey-lightest gap-2 pb-4">
		<div class="bg-green-lighter rounded">
			<div class="flex justify-between items-center p-3">
				<div class="flex gap-2 items-center text-green-dark font-bold">
					<app-icon [icon]="ICON.DOLLAR"></app-icon>
					<p>Edit direction of total amount</p>
				</div>
			</div>
		</div>
		<app-dropdown
			class="px-3 mb-5 mt-3"
			[ngModel]="directionOfFeeString[displayIn]"
			label="Display LTT & MLTT amounts in"
			[itemGroups]="displayOptions"
			(onSelect)="setDisplayIn($event)"
			[disabled]="isDisabled"
			readonly="true"
		></app-dropdown>
		<ng-container
			*ngIf="ltt?.mltt?.applied && displayIn !== directionOfFeeType.NONE"
		>
			<app-checkbox
				type="clear"
				class="px-3 mb-3"
				[(ngModel)]="separateEntries"
			>
				Import LTT and MLTT as separate entries
			</app-checkbox>
			<app-radio-group
				class="px-3 mb-2"
				[items]="showFeeOptions"
				type="compact"
				label="Show MLTT admin fee in"
				[ngModel]="showAdminFeeIn"
				(ngModelChange)="setShowAdminFeeIn($event)"
			></app-radio-group>
		</ng-container>
	</div>
	<div class="flex justify-between">
		<app-button size="small" btn="secondary" (click)="close()"
			>Cancel</app-button
		>
		<app-button size="small" btn="primary" (click)="save()">Save</app-button>
	</div>
</div>
